import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwskvx3h2w: FaireProductEntity = {
  token: "p_rwskvx3h2w",
  type: "product",
  name: "Hot Garlic Chili Crisp — Original (16oz) All Natural",
  brandToken: "b_qe6cjwf7wv",
  brandName: "Mama Teav's",
  imageUrl:
    "https://cdn.faire.com/fastly/28d0a07c11107eef0d79ce5f5f881d0af5804fd9aff4b8fa39e38573ae5f3580.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35a0a6f050816d81df3d8f9d35f0e06ac96a02862c64e927d35d68eeeb140b31.png",
    "https://cdn.faire.com/fastly/5fdf68f75c89fdc2a08d2c2aa0f1dba22ce0d46faef18ab71b174695b1da22e7.png",
    "https://cdn.faire.com/fastly/1402f435f43f416f33eedd28e57c151541d10206779890ed5f79fab450386c92.png",
    "https://cdn.faire.com/fastly/d5fbb72f285f8ff8c17ea8d441bae30619bbcbcc2236bba38186832d8a37e517.png",
  ],
  priceDollars: 22,
  description:
    "By popular demand, our large 16 oz jars are officially available on Faire. \n\nMaybe you’re original at heart. Maybe you just prefer to save your sweat for the gym. \n\nWhatever the case, this chili crisp oil brings the umami crunch and the garlicky depth—on your terms. Our Hot Garlic chili crisp will save you from a blandwich. Makes rice extra nice. Transforms pizza, toast, soups or noodles. Share a spoonful and gain a friend. Hoard the jar and risk karmic retribution—mom’s superstition, not ours. \n\nSeven whole ingredients. Infinite uses. Our Chili Crisp keeps it simple so the flavor can speak for itself —bold heat, savory depth, and a satisfying crunch that makes everything taste better. Whether your customers are heat-seekers or just great-food lovers, this is the one condiment they didn't know they needed.\n\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:29.805Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
